// `products.image` (and the copies of it on cart, wish and review) is a MySQL
// JSON column, but what actually reaches a component is not consistent:
//
//   - usually a JSON-encoded array string:  '["https://...a.jpg"]'
//   - sometimes a bare URL:                 'https://...a.jpg'
//   - sometimes an array that was already parsed higher up the tree
//   - sometimes that array coerced back to text: 'https://a.jpg,https://b.jpg'
//
// A bare JSON.parse handles only the first. The others throw, and because these
// calls sit in render bodies an uncaught SyntaxError blanks the entire page
// rather than dropping one thumbnail. Everything goes through here instead.

export function parseImages(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value !== "string") return [];

  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
    if (typeof parsed === "string" && parsed.trim()) return [parsed.trim()];
    return [];
  } catch {
    const raw = value.trim();
    if (!raw) return [];
    // String(["a.jpg", "b.jpg"]) === "a.jpg,b.jpg" -- an array that lost its
    // JSON somewhere upstream.
    if (raw.includes(",") && /^https?:\/\//i.test(raw)) {
      return raw
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);
    }
    return [raw];
  }
}

// The thumbnail. `fallback` is returned when a product has no usable image.
export function firstImage(value, fallback = "") {
  const images = parseImages(value);
  return images.length > 0 ? images[0] : fallback;
}
